import * as React from 'react';

import { UIHeading1, UIText1 } from '@cian/ui-kit';
import { ColoredThemeButton } from '../ReferrerHero';

import imgSrc from './assets/img.svg';
import * as styles from './styles.css';

interface IReferralHeroProps {
  stickyRef?: React.Ref<HTMLDivElement>;
  onClick: () => void;
}

export const ReferralHero: React.FC<IReferralHeroProps> = ({ stickyRef, onClick }) => {
  return (
    <div className={styles['container']} ref={stickyRef}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <UIHeading1 color="text-on-bright-default">
            Вам посоветовали <br /> профи от Циана
          </UIHeading1>
          <UIText1 color="text-on-bright-default">Поможем купить или продать недвижимость выгодно и спокойно</UIText1>

          <ColoredThemeButton size="L" onClick={onClick}>
            Получить консультацию
          </ColoredThemeButton>
        </div>

        <div className={styles['img']}>
          <img src={imgSrc} alt="Вам посоветовали Сделку" />
        </div>
      </div>
    </div>
  );
};
